﻿import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({ name: 'extract' })
export class ExtractPipe implements PipeTransform {
    transform(value, args: string): any {
        if (!value || !args) return value;
        return value.map(item => get(item, args));
    }
}
